import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    identity() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          url: API_BASE + `/identity/`,
          method: "get"
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          this.$store.commit("setRole", response.data);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    ticket(params) {
      var data = new FormData();

      for (const [key, value] of Object.entries(params)) {
        data.append(key, value);
      }

      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          url: API_BASE + `/ticket/`,
          method: "post",
          data
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
